var module = angular.module('octopusApp.certificates');

module.controller('CertificateDetailsController', function ($scope, $stateParams, busy, octopusRepository,
                                                            unsavedChanges, octoDialog, $state, $uibModal, $q) {
    var isLoadingDetails = $scope.isLoadingDetails = busy.create();
    var isLoadingEdit = $scope.isLoadingEdit = busy.create();
    var isLoadingUsage = $scope.isLoadingUsage = busy.create();
    var isSaving = $scope.isSaving = busy.create();
    var certificateId = $stateParams["id"];

    $scope.dateFormat = 'EEEE, MMMM d, yyyy HH:mm a Z';

    $scope.tab = 'details';
    $scope.changeTab = function (v) {
        $scope.tab = v;
    };

    var loadCertificate = octopusRepository.Certificates.get(certificateId).then(function (certificate) {
        $scope.certificate = certificate;

        if (certificate.ReplacedBy) {
           return octopusRepository.Certificates.get(certificate.ReplacedBy).then(function(replacedBy) {
               $scope.replacedBy = replacedBy;
           });
        }
    });

    isLoadingDetails.promise(loadCertificate);
    isLoadingEdit.promises([loadCertificate, loadEnvironmentsAndTenants()]);
    isLoadingUsage.promise(loadUsages());

    $scope.save = function () {
        isSaving.promise(octopusRepository.Certificates.save($scope.certificate).then(function () {
            unsavedChanges.saved();
            $state.go('app.library.certificates.index');
        }));
    };

    $scope.archive = function () {
        octoDialog.asyncConfirm({
            title: "Archive Certificate",
            message: "Are you sure you want to archive this certificate?",
            executeButtonClass: "btn-warning",
            executeButtonText: "Archive",
            execute: function (dialog) {
                dialog.busy.promise(octopusRepository.Certificates.archive($scope.certificate).then(function () {
                    dialog.dismiss();
                    $state.reload();
                }));
            }
        });
    };

    $scope.unarchive = function () {
        octoDialog.asyncConfirm({
            title: "Unarchive Certificate",
            message: "Are you sure you want to unarchive this certificate?",
            executeButtonClass: "btn-success",
            executeButtonText: "Unarchive",
            execute: function (dialog) {
                dialog.busy.promise(octopusRepository.Certificates.unarchive($scope.certificate).then(function () {
                    dialog.dismiss();
                    $state.reload();
                }));
            }
        });
    };

    $scope.download = function () {
        $uibModal.open({
            backdrop: true,
            keyboard: true,
            templateUrl: 'areas/certificates/details/certificate_download_dialog.html',
            controller: "CertificateDownloadDialogController",
            resolve: {
                certificate: $scope.certificate
            }
        });
    };

    $scope.replace = function() {
        $uibModal.open({
            backdrop: true,
            keyboard: true,
            templateUrl: 'areas/certificates/details/certificate_replace_dialog.html',
            controller: "CertificateReplaceDialogController",
            resolve: {
                certificate: $scope.certificate
            }
        }).result.then(function(replaced){

            if (!replaced) {
                return;
            }

           $state.go($state.current, {id: replaced.Id});
        });
    };

    $scope.hasUsages = function () {
        if (!$scope.usages) {
            return false;
        }

        return $scope.usages.length > 0;
    };

    function loadEnvironmentsAndTenants() {
        var promises = [];

        promises.push(octopusRepository.Environments.all().then(function (environments) {
            $scope.environments = environments;
        }));

        // If Tenancy feature is enabled
        if (octopusRepository.Tenants) {
            promises.push(
                octopusRepository.Tenants.all().then(function (tenants) {
                    $scope.tenants = tenants;
                }));
        }

        return $q.all(promises);
    }

    function loadUsages() {
        return loadCertificate.then(function () {
            return octopusRepository.Certificates.usage($scope.certificate).then(function (usage) {
                // Combine Project and Variable Set usages into an array of the form:
                // { variableName: '', ownerName: '', ownerLink: '', ownerType: '' }
                $scope.usages = _.chain(usage.ProjectUsages)
                    .map(function (projectUsage) {
                        return _.map(projectUsage.Variables, function (projVar) {
                            return {
                                variableName: projVar,
                                ownerName: projectUsage.Owner.Name,
                                ownerLink: '#/projects/' + projectUsage.Owner.Slug,
                                ownerType: 'Project'
                            };
                        });
                    })
                    .union(_.map(usage.LibraryVariableSetUsages, function (lvsUsage) {
                        return _.map(lvsUsage.Variables, function (lvsVar) {
                            return {
                                variableName: lvsVar,
                                ownerName: lvsUsage.Owner.Name,
                                ownerLink: '#/library/variables/' + lvsUsage.Owner.Id,
                                ownerType: 'Variable Set'
                            };
                        });
                    }))
                    .union(_.map(usage.TenantUsages, function(tenantUsage) {
                        return _.map(tenantUsage.Variables, function(tenantVar){
                          return {
                              variableName: tenantVar,
                              ownerName: tenantUsage.Owner.Name,
                              ownerLink: "#/tenants/" + tenantUsage.Owner.Id + "/variables",
                              ownerType: 'Tenant'
                          };
                        });
                    }))
                    .flatten().value();
            });
        });
    }
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/certificates/details/certificate_details_controller.js
// module id = 3699201545924420
// module chunks = 1